/**
 * Browser-side environment detection, the JS counterpart of the server's Core::isDevEnv().
 */
export class Env {
    /**
     * True when the page is served by a local dev web server. The server stamps the
     * authoritative answer onto <body data-is-dev-env> at render time (default.twig); that
     * always wins when present. Pages rendered outside the default layout fall back to a
     * heuristic covering two cases: a localhost/loopback hostname (worktree dev web servers
     * get per-worktree ports, so the port alone can't identify dev), and the main repo's dev
     * web port on any hostname (so phone-on-LAN testing against the dev machine's IP still
     * counts as dev).
     * @returns {boolean}
     */
    static isDevEnv() {
        const stamped = document.body?.dataset?.isDevEnv;
        if (stamped !== undefined) {
            return stamped === "1";
        }
        const { hostname, port } = window.location;
        const isLocalHostname = hostname === "localhost" || hostname === "127.0.0.1";
        return isLocalHostname || port === "8082";
    }
}
